import React from 'react';
import api from '../../services/rewardsApi';
import Text from '../../components/Text';

export async function getUserPoints({ cnpj, setUsers, setLoading, snackbar }) {
  setLoading(true);

  try {
    const response = await api.get(`users/points?cnpj=${cnpj}`);
    const { data } = response.data;

    setUsers(data);
  } catch (error) {
    snackbar.show(<Text>Erro ao carregar o ranking de pontos</Text>, {
      type: 'error',
    });
  } finally {
    setLoading(false);
  }
}
